import { render, staticRenderFns } from "./enrollmentResult.vue?vue&type=template&id=8ec0587c&scoped=true&"
import script from "./enrollmentResult.vue?vue&type=script&lang=js&"
export * from "./enrollmentResult.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentResult.vue?vue&type=style&index=0&id=8ec0587c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec0587c",
  null
  
)

export default component.exports